import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { cloneDeep } from 'lodash-es';

import {
  RangeOrRelativeDateInputModel
} from 'shared/components/range-or-relative-date-input/range-or-relative-date-input.component';

export interface DateRangeUserDialogData {
  campaignId: string;
  title: string;
  targetType: 'EntityType' | 'EntityConnectionType' | string;
  forTypeText?: string;
  dateRange: RangeOrRelativeDateInputModel;
  userIds: string[];
  operator?: string;
  hideAnyOrAll?: boolean;
  showOperators?: boolean;
}

export interface DateRangeUsersDialogCloseData {
  dateRange: RangeOrRelativeDateInputModel;
  userIds: any[];
  operator?: string;
}

@Component({
  selector: 'app-date-range-users-operator',
  templateUrl: './date-range-users-operator.dialog.html',
  styleUrls: ['./date-range-users-operator.dialog.scss']
})

export class DateRangeUsersOperatorDialog  {
  // We will copy the data here to avoid mutations
  dataCopy: DateRangeUsersDialogCloseData;

  campaignId: string;
  showOperators = false;
  forTypeText = '';

  get targetTypeText() {
    if (this.data.targetType === 'EntityConnectionType') {
      return 'connections';
    }
    return 'entities';
  }

  static open(dialog: MatDialog, config: MatDialogConfig<DateRangeUserDialogData>) {
    return dialog.open<DateRangeUsersOperatorDialog, DateRangeUserDialogData, DateRangeUsersDialogCloseData>
      (DateRangeUsersOperatorDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<DateRangeUsersOperatorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DateRangeUserDialogData
  ) {
    if (data.forTypeText) { this.forTypeText = data.forTypeText; }

    // If we have operator options, then we will show the operators
    // "ie. include any, exclude any"
    this.showOperators = data.showOperators ?? false;

    this.campaignId = data.campaignId;


    this.dataCopy = cloneDeep({
      dateRange: data.dateRange,
      userIds: data.userIds || [],
      operator: data.operator,
    });
  }


  userIdsChanged(userIds: string[]) {
    this.dataCopy.userIds = userIds;
  }

  dateRangeChanged(dateRange: RangeOrRelativeDateInputModel) {
    this.dataCopy.dateRange = dateRange;
  }

  operatorChanged(operator: string) {
    this.dataCopy.operator = operator;
  }

  onDone() {
    this.close(this.dataCopy);
  }

  close(data: DateRangeUsersDialogCloseData = null) {
    if (data) {
      return this.dialogRef.close(data);
    }
    this.dialogRef.close({
      dateRange: this.data.dateRange,
      userIds: this.data.userIds,
      operator: this.data.operator,
    });
  }
}
